import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { Accordion, AccordionDetails, AccordionSummary, Box, Typography } from '@mui/material';
import { useTenant } from 'probonio-shared-ui/module/me';
import { Trans, useTranslation } from 'react-i18next';
import { HorizontalBox } from '../../component/layout/BoxLayout';

export const NonCashBenefitInfoText: React.FC = () => {
  const { tenant } = useTenant();
  const { t } = useTranslation('benefitsModule');

  return (
    <Accordion
      sx={{
        marginBottom: 1.5,
        borderRadius: 1,
        '&:before': {
          display: 'none',
        },
      }}
    >
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <HorizontalBox alignItems="center">
          <InfoOutlinedIcon sx={{ marginRight: 1 }} />
          {t('nonCashBenefits.infoTitle')}
        </HorizontalBox>
      </AccordionSummary>
      <AccordionDetails>
        {tenant?.nonCashBenefits.map(nonCashBenefit => (
          <Box key={`infoText-${nonCashBenefit}`}>
            <Typography mt={3} variant="h3">
              {t(`nonCashBenefits.${nonCashBenefit}.name`)}
            </Typography>
            <Trans i18nKey={`benefitsModule:nonCashBenefits.${nonCashBenefit}.infoText`}></Trans>
          </Box>
        ))}
      </AccordionDetails>
    </Accordion>
  );
};
